type IProps = {
	progress: number;
};

export default function ProgressBar(props: IProps) {
	const progress = props.progress;

	return (
		<div className="relative h-3 w-full max-w-xs rounded-full bg-gradient-to-r from-[#D6FFC2] to-[#FF929F]">
			<div
				className="absolute bottom-0 left-0 top-0 max-w-xs rounded-full bg-gray-200"
				style={{ width: `${progress}%`, borderRight: "-100px" }}
			/>
		</div>
	);
}
